module.exports = __webpack_public_path__ + "static/media/ru_call_fake.63129516.mp3";